<template>
    <div class="tbl-collapse">
        <div class="thead">
            <div class="row">
                <span v-if="menuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="checkbox">
                    <input type="checkbox" name="select-all" class="checkbox txt-none"
                            id="related-wtl-all"
                            v-model="btnCheckAll"
                    >
                    <label for="related-wtl-all">{{$t('LABEL.SELECT_ALL')}}</label>
                </span>
                <span class="cell" data-size="auto">
                    <button type="button" class="buttons-tbl-header" :data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            @click="callSetSortColumn('titl')">{{ $t('COMPLIANCE.WHITELIST.HEADER.NAME')}}<!--이름--></button>
                </span>
                <span class="cell" data-align="center">
                        <button type="button" class="buttons-tbl-header" :data-type="sortColumn !== 'rsrcCnt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                @click="callSetSortColumn('rsrcCnt')">{{ $t('COMPLIANCE.WHITELIST.HEADER.RESOURCE')}}<!--리소스--></button>
                </span>
                <span class="cell" data-align="center">
                    <button type="button" class="buttons-tbl-header" :data-type="sortColumn !== 'updtDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            @click="callSetSortColumn('updtDt')">{{ $t('COMPLIANCE.WHITELIST.HEADER.LAST_UPDATED')}}<!--마지막 업데이트--></button>
                </span>
                <span class="cell" data-align="center">
                    <button type="button" class="buttons-tbl-header" :data-type="sortColumn !== 'updtUserNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            @click="callSetSortColumn('updtUserNm')">{{ $t('COMPLIANCE.WHITELIST.HEADER.UPDATED_USER')}}<!--업데이트 사용자--></button>
                </span>
                <span class="cell" data-align="center">
                    {{ $t('COMMON.TABLE.DETAILS')}}<!--상세 정보-->
                </span>
            </div>
        </div>
        <div v-if="whiteListPending" class="tbody">
            <div-loading ></div-loading>
        </div>
        <div v-else class="tbody">
            <div class="row" v-if="whiteListItems.length === 0">
                <div class="cells">
                    <span class="cell" data-none>
                        {{ $t('COMPLIANCE.WHITELIST.NONE_01')}}<!--화이트리스트를 추가해 주세요.-->
                        <br>
                        {{ $t('COMPLIANCE.WHITELIST.NONE_02')}}
                    </span>
                </div>
            </div>
            <div class="row" v-for="(wtl,idx) in whiteListItems" :data-expand="wtl.isOpen === true ? true : null" :key="idx">
                <div class="cells"  :data-deleted="wtl.delYn === 'Y' ? true : null">
                    <span v-if="menuAuth == constants.AUTH_TYPE.EDIT" class="cell" data-size="checkbox">
                        <input type="checkbox" class="checkbox txt-none"
                            name="whiteList"
                            :id="wtl.wtlId"
                            :value="wtl.wtlId"
                            v-model="whiteList"
                        >
                        <label :for="wtl.wtlId">{{$t('LABEL.SELECT')}}</label>
                    </span>
                    <span v-if="wtl.delYn === 'N'" class="cell" data-size="auto">{{wtl.titl}}</span>
                    <span v-else class="cell" data-size="auto">
                        <del>{{wtl.titl}}</del>
                        <span class="chip selected" data-size="s">{{ $t('COMPLIANCE.WHITELIST.DELETED')}}<!--삭제됨--></span>
                    </span>
                    <span class="cell" data-align="center">
                        {{wtl.rsrcCnt}}
                    </span>
                    <span class="cell" data-align="center">
                        <time datetime="">{{wtl.updtDt ? convertUtcTimezoneToLocal(wtl.updtDt) : ''}}</time>
                    </span>
                    <span class="cell" data-align="center">
                            {{wtl.updtUserNm}}
                        </span>
                    <span class="cell" data-align="center">
                        <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="wtl.isOpen === true ? true : null"
                                :disabled:="wtl.delYn === 'Y' ? true : null"
                                @click="openWhitelistDetail(idx, wtl)">collapse / expand</button>
                    </span>
                </div>
                <div class="expand-container" >
                    <table class="tbl-inner">
                        <caption></caption>
                        <thead>
                        <tr>
                            <th scope="col">{{ $t('COMPLIANCE.WHITELIST.HEADER.ACCOUNT_NAME')}}<!--계정 이름 (별칭)--></th>
                            <th scope="col">{{ $t('COMPLIANCE.WHITELIST.HEADER.PRODUCT')}}<!--제품--></th>
                            <th scope="col">{{ $t('COMPLIANCE.WHITELIST.HEADER.REGION')}}<!--지역--></th>
                            <th scope="col">{{ $t('COMPLIANCE.WHITELIST.HEADER.RESOURCE_NAME')}}<!--리소스 이름--></th>
                            <th scope="col">{{ $t('COMPLIANCE.WHITELIST.HEADER.RESOURCE_ID')}}<!--리소스 ID--></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(rsrc, idx) in wtl.rsrcList" :key="idx">
                            <td>{{rsrc.accId}}({{rsrc.accAlias}})</td>
                            <td>{{rsrc.rsrcType}}</td>
                            <td>{{rsrc.rgnId}}</td>
                            <td>{{rsrc.instNm}}</td>
                            <td>{{rsrc.instId}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CmplWhiteList",
    data() {
        return {
            btnCheckAll: false,
            whiteList: []
        }
    },
    props: {
        sortOrder: String,
        sortColumn: String,
        whiteListPending: Boolean,
        menuAuth: String,
        whiteListItems: Array,
        slctedAppliedWL: Array,
        callSetSortColumn: {
            type: Function,
            default: ()=>{}
        },
        callCheckAll: {
            type: Function,
            default: ()=>{}
        },
        callSlctAppliedWL: {
            type: Function,
            default: ()=>{}
        },
    },
    watch: {
        btnCheckAll(newVal, olv) {
            if (newVal) {
                this.callCheckAll(newVal);
            } else if (this.whiteListItems.length === this.slctedAppliedWL.length) {
                this.callCheckAll(newVal)
            }
        },
        slctedAppliedWL(newVal, olv) {
            this.whiteList = newVal;
        },
        whiteList(newVal, olv) {
            if (newVal.length === this.whiteListItems.length) {
                this.btnCheckAll = true;
            } else {
                this.btnCheckAll = false;
            }
            this.callSlctAppliedWL(newVal);
        }
    },
    methods: {
        async openWhitelistDetail(idx,wtl) {
            let target = $('.tbl-collapse .buttons-icon[data-icon=expand]').eq(idx);
            let isOpen = typeof(target.attr('data-expand')) !== 'undefined';

            if (isOpen) {
                wtl.isOpen = false;
                delete wtl.rsrcList;
                target.toggleAttr('data-expand', '').closest('.row').removeAttr('data-expand');
            } else {
                wtl.isOpen = true;
                target.toggleAttr('data-expand', '').closest('.row').toggleAttr('data-expand', true);
                const url = "/api/governance/whielist/mapping/rsrc";
                const header = {
                    cmpnId: wtl.cmpnId,
                    wtlId: wtl.wtlId
                };

                const result = await this.http.post(url, JSON.stringify(header));
                if(result.status === 200){
                    target.addClass('open');
                    wtl.rsrcList = result.data.result.list;
                }
            }
        },
        convertUtcTimezoneToLocal: function(date) {
            return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
        },
    }
}
</script>

<style scoped>
.tbl-collapse {
    border-style: solid;
    border-width: 1px;
    margin-top: 4px;
    border-radius: 4px;
    border-color: #e0e6e6;
}
</style>


// WEBPACK FOOTER //
// src/components/compliance/components/CmplWhiteList.vue